import classNames from "classnames";
import { ArrowRight } from "lucide-react";
import { useTranslation } from "next-i18next";
import Link from "next/link";
import styles from "./style.module.css";

function ViewAll(props: any) {
  const {
    href, asPath = href, openNewTab = null, title, className = "",
    onClick,
  } = props;
  const { t } = useTranslation("home");

  if (!href) {
    return null;
  }

  return (
    (
      <Link
        href={href}
        as={asPath}
        className={`text-right p-l-20 pointer ${styles.viewAll} ${className}`}
        target={openNewTab}
        title={title}
        onClick={onClick}
      >

        {t("View All")}
        <span className={classNames("hidden-xs", styles.icon)}>
          <ArrowRight size={20} />
        </span>

      </Link>
    )
  );
}

export default ViewAll;
